import { render } from "./padel-radio.template.html?vue&type=template&id=8b4d68e2&scoped=true"
import script from "./PadelRadio.vue?vue&type=script&lang=ts"
export * from "./PadelRadio.vue?vue&type=script&lang=ts"

import "./PadelRadio.vue?vue&type=style&index=0&id=8b4d68e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b4d68e2"

export default script